import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

export function FinalCTASection() {
  return (
    <section className="py-16 md:py-24 bg-primary text-primary-foreground">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-foreground/10 mb-6">
          <Sparkles className="h-4 w-4" />
          <span className="text-sm font-medium">Premier scan gratuit</span>
        </div>
        
        <h2 className="text-2xl md:text-4xl font-bold mb-4">
          Votre premier scan est gratuit.
        </h2>
        
        <p className="text-lg text-primary-foreground/80 mb-8 max-w-2xl mx-auto">
          Testez RepriScan sur un vrai dossier, sans engagement ni carte bancaire. 
          Voyez en quelques minutes si un projet mérite votre temps.
        </p>
        
        <Link to="/auth">
          <Button 
            size="lg" 
            variant="secondary" 
            className="gap-2 bg-primary-foreground text-primary hover:bg-primary-foreground/90"
          >
            Commencer mon premier scan
            <ArrowRight className="h-4 w-4" />
          </Button>
        </Link>
      </div>
    </section>
  );
}
